module.exports = __webpack_public_path__ + "img/vivo-fonts.4cfa75c6.svg";